import { render } from "./AdminEventsList.vue?vue&type=template&id=066c2a28&scoped=true&ts=true"
import script from "./AdminEventsList.vue?vue&type=script&lang=ts"
export * from "./AdminEventsList.vue?vue&type=script&lang=ts"

import "./AdminEventsList.vue?vue&type=style&index=0&id=066c2a28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066c2a28"]])

export default __exports__